<script setup lang="ts">
  import { CallSentiment } from '@api/models';
  import * as changeCase from 'change-case';
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';
  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<{
      sentiment: CallSentiment | null;
      emoji?: boolean;
      iconClass?: HTMLAttributes['class'];
    }>(),
    { iconClass: 'text-sm far' },
  );

  const sentimentIcon = computed<string>(() => {
    switch (props.sentiment) {
      case CallSentiment.POSITIVE:
        return 'fa-face-smile text-success';
      case CallSentiment.NEGATIVE:
        return 'fa-face-frown text-destructive';
      case CallSentiment.NEUTRAL:
        return 'fa-face-meh text-muted-foreground';
      case CallSentiment.UNKNOWN:
      default:
        return 'fa-question text-muted-foreground';
    }
  });

  const sentimentEmoji = computed<string>(() => {
    switch (props.sentiment) {
      case CallSentiment.POSITIVE:
        return String.fromCodePoint(0x1f600);
      case CallSentiment.NEGATIVE:
        return String.fromCodePoint(0x1f620);
      case CallSentiment.NEUTRAL:
        return String.fromCodePoint(0x1f610);
      case CallSentiment.UNKNOWN:
      default:
        return String.fromCodePoint(0x2753);
    }
  });
</script>
<template>
  <Tooltip>
    <TooltipTrigger v-bind="$attrs">
      <template v-if="emoji">{{ sentimentEmoji }}</template>
      <i v-else :class="cn(sentimentIcon, iconClass)" />
    </TooltipTrigger>

    <TooltipContent>
      {{ sentiment ? changeCase.capitalCase(sentiment) : 'Unknown' }}
    </TooltipContent>
  </Tooltip>
</template>

<style scoped></style>
